export const PLUGIN_PLAN_CODE = 'PLUGIN_PLAN';
export const PLUGIN_PLAN_NAME = 'Plugin';

export const PLUGIN_PLAN_LIMITS = {
    workspaceUsers: 1,
    storeConnections: 1,
    otherIntegrationConnections: 4,
    totalIntegrationConnections: 5,
};

interface PluginWorkspaceStateInput {
    currentWorkspacePlanCode?: string | null;
    currentWorkspacePlanName?: string | null;
    currentWorkspacePlanProvider?: string | null;
    billingSummaryPlanCode?: string | null;
    billingSummaryPlanName?: string | null;
    billingSummaryProvider?: string | null;
    creditSummaryPlanCode?: string | null;
    creditSummaryPlanName?: string | null;
    creditSummaryProvider?: string | null;
    userPlanCode?: string | null;
    userPlanName?: string | null;
    userPlanProvider?: string | null;
    memberLimit?: {
        limitValue?: number | string | null;
        unlimited?: boolean | null;
    } | null;
}

const normalizeToken = (value?: string | null): string => (value || '').trim().toUpperCase();

const normalizeProvider = (value?: string | null): string => (value || '').trim().toLowerCase();

const normalizePositiveInteger = (value?: number | string | null): number | null => {
    if (value === undefined || value === null || value === '') {
        return null;
    }

    const parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : null;
};

export const isPluginPlanCode = (planCode?: string | null): boolean => (
    normalizeToken(planCode) === PLUGIN_PLAN_CODE
);

export const isPluginPlanProvider = (provider?: string | null): boolean => {
    const normalized = normalizeProvider(provider);
    return provider === 'plugin' || normalized === 'plugin';
};

export const resolvePluginWorkspaceState = ({
    currentWorkspacePlanCode,
    currentWorkspacePlanName,
    currentWorkspacePlanProvider,
    billingSummaryPlanCode,
    billingSummaryPlanName,
    billingSummaryProvider,
    creditSummaryPlanCode,
    creditSummaryPlanName,
    creditSummaryProvider,
    userPlanCode,
    userPlanName,
    userPlanProvider,
    memberLimit,
}: PluginWorkspaceStateInput) => {
    const isPluginWorkspace = [
        currentWorkspacePlanCode,
        billingSummaryPlanCode,
        creditSummaryPlanCode,
        userPlanCode,
    ].some(isPluginPlanCode) || [
        currentWorkspacePlanProvider,
        billingSummaryProvider,
        creditSummaryProvider,
        userPlanProvider,
    ].some(isPluginPlanProvider);

    const entitlementMemberLimit = memberLimit?.unlimited
        ? null
        : normalizePositiveInteger(memberLimit?.limitValue);

    return {
        isPluginWorkspace,
        planName: isPluginWorkspace
            ? PLUGIN_PLAN_NAME
            : currentWorkspacePlanName
            || billingSummaryPlanName
            || creditSummaryPlanName
            || userPlanName
            || PLUGIN_PLAN_NAME,
        limits: {
            ...PLUGIN_PLAN_LIMITS,
            workspaceUsers: entitlementMemberLimit ?? PLUGIN_PLAN_LIMITS.workspaceUsers,
        },
    };
};
